import { abyssColors } from '@/theme/colors';
import { CircularProgress, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useMemo } from 'react';

type Props = {
  pointOfInterestsCount?: number | null;
  verifiedPointOfInterestsCount?: number | null;
};

export const FieldVerificationStatus = ({
  pointOfInterestsCount = 1,
  verifiedPointOfInterestsCount = 1,
}: Props) => {
  const { isVerified, verifiedProgressValue } = useMemo(() => {
    return {
      isVerified: pointOfInterestsCount === verifiedPointOfInterestsCount,
      verifiedProgressValue:
        pointOfInterestsCount && verifiedPointOfInterestsCount
          ? (verifiedPointOfInterestsCount / pointOfInterestsCount) * 100
          : 0,
    };
  }, [pointOfInterestsCount, verifiedPointOfInterestsCount]);

  return (
    <Stack
      direction="row"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {isVerified ? (
        <>
          <CheckCircleIcon
            sx={{
              color: abyssColors.success[500],
              width: '16px',
              mr: 1,
            }}
          />
          <Typography variant="body2">Verified</Typography>
        </>
      ) : (
        <>
          <CircularProgress
            variant="determinate"
            size={20}
            sx={{ color: abyssColors.secondary[600], mr: 1 }}
            value={verifiedProgressValue}
          />
          <Typography variant="body2">{`${verifiedPointOfInterestsCount}/${pointOfInterestsCount}`}</Typography>
        </>
      )}
    </Stack>
  );
};
